import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from './../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ConsultationProcessService } from '../consultation-process.service';
import {
  ConsultationStep, GroupConsultationStep, ConsultationComplelte,
  ConsultationStepInfo
} from '../../../models/consultation/consultation.model';
import { AppConstants } from '../../../shared/constants/constants';
import { SharedService } from '../../../shared/services/share.services';

@Component({
  selector: 'base-consultation',
  template: ''
})

export class BaseConsultationComponent implements OnInit, OnDestroy {
  public lastedStep; //  = ConsultationStep.PatientDetails;
  public activeStep; // = ConsultationStep.PatientDetails;
  public navigateUrl = '';
  public subscription: Subscription;
  public menuSubscription: Subscription;
  public filterParam;
  public isMoveNextStep = false;
  public dataRow;
  public tripInfo: any = {
    country: '',
    departureDate: 0,
    returnDate: 0,
  };
  public isDataEntryMode = false;
  public fromSelectDisease = false;

  constructor(public dialogService: DialogService,
    public consultationProcessService: ConsultationProcessService,
    public router: Router,
    public activeRouter: ActivatedRoute,
    @Inject('currentStep') public currentStep: number = 0,
    @Inject('isGroup') public isGroup: boolean = false) {
    this.activeStep = this.currentStep;
    // get param from router
    this.filterParam = {
      id: this.activeRouter.snapshot.params['id'],
      isFromHistory: this.activeRouter.snapshot.params['isFromHistory'] || null
    };

    if (this.activeRouter.snapshot.params['patientId']) {
      this.filterParam['patientId'] = this.activeRouter.snapshot.params['patientId'];
    } else if (isGroup === false && this.activeStep === ConsultationStep.TripInformation) {
      this.activeStep = GroupConsultationStep.TripInformation;
      this.isGroup = true;
    }

    // get next,prev action from consultationProcessBar
    this.subscription = this.consultationProcessService.getAction().subscribe(
      data => {
        this.navigateUrl = data.stepUrl;
        this.isMoveNextStep = data.isNext;
        this.fromSelectDisease = data.fromSelectDisease;
        this.changeConsultationStep();
      });

    // if this is cash sale page then do not need to anounce or validate step
    if (currentStep === ConsultationStep.InvoiceComplete && !this.filterParam.id) {
      return;
    }
    // announce step to progress bar
    if (this.isGroup && this.filterParam.id != null) {
      // call get step consultation for group
      this.consultationProcessService.getGroupConsultationStep(this.filterParam.id).subscribe(result => {
        this.updateConsultationStep(result.json());
      });
    } else if (this.activeStep === ConsultationStep.PatientDetails && this.filterParam.id != "undefined" && this.filterParam.id != null ) {
      this.consultationProcessService.beginConsultationProcess(this.filterParam.id).subscribe(
        (result) => {
          this.updateConsultationStep(result.json());
        }
      );
    } else if (this.activeStep === ConsultationStep.AdministerVaccine && this.filterParam.id != "undefined" && this.filterParam.id != null) 
    {
      this.consultationProcessService.changeStatus(this.filterParam.id).subscribe(
        (result) => {
          this.updateConsultationStep(result.json());
        });
    } else { 
      if(this.filterParam.id != "undefined" && this.filterParam.id != null )
      {
        this.consultationProcessService.getConsultationStep(this.filterParam.id).subscribe(
          (result) => {
            this.updateConsultationStep(result.json());
          });
      }
    }
  }

  ngOnInit() {
   
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    this.subscription.unsubscribe();
    if (this.menuSubscription) {
      this.menuSubscription.unsubscribe();
    }
  }

  /**
   * redirect to another step in consultation
   */
  navigateAction() {
    if (this.filterParam.patientId) {
      this.router.navigate([this.navigateUrl, this.filterParam.id, this.filterParam.patientId]);
    } else {
      this.router.navigate([this.navigateUrl, this.filterParam.id]);
    }
  }

  updateConsultationStep(stepData) {
    if (stepData.hasOwnProperty('step')) {
      this.lastedStep = stepData.step;
    }
    this.validateStep(this.lastedStep);
    const stepObj = {
      id: this.filterParam.id,
      step: this.activeStep,
      lastedStep: this.lastedStep
    };
    if (this.filterParam.patientId) {
      stepObj['patientId'] = this.filterParam.patientId;
    }
    this.consultationProcessService.announceStep(stepObj);
  }

  /**
   * submit consultation step data
   * will be over write in inherate component
   */
  submitData() {
  }

  /**
   * this function will be called when user click on breakscrum step or next, prev button
   */
  changeConsultationStep() {
    this.submitData();
  }

  validateStep(lastedStep) {
    if (!this.filterParam.isFromHistory) {
      // The consultation has been finished, then system displays waiting room page
      const step = ConsultationComplelte.filter(s => s === lastedStep);
      if (step.length > 0) {
        this.router.navigate(['consultation/waiting-room']);
      }
      // The stage has been passed, and user cannot navigate back to that stage by Previous Step button,
      // then system displays the latest consultation stage
      if (lastedStep >= ConsultationStep.AdministerVaccination && this.activeStep < ConsultationStep.AdministerVaccination) {
        // fix bug : SD10001680-173
        if (lastedStep === ConsultationStep.AdministerVaccination &&
          this.activeRouter.snapshot.queryParams['isEdit'] && this.activeRouter.snapshot.queryParams['isEdit'] == 'true') {
          return;
        }
        this.moveToStep(lastedStep);
      } else if (lastedStep < this.activeStep) {
        // fix bug SD10001680-305
        this.moveToStep(lastedStep);
      }
    }
  }

  moveToStep(lastedStep) {
    const stepInfo = ConsultationStepInfo.filter(s => s.step === lastedStep);
    if (stepInfo.length > 0) {
      this.router.navigate([stepInfo[0].routerLink, this.filterParam.id, this.filterParam.patientId]);
    }
  }

  showDataError(stepObj) {
    if (stepObj.hasOwnProperty('message') && stepObj.hasOwnProperty('step')) {
      this.dialogService.openErrorDialog({ message: stepObj.message }).subscribe(
        (result) => {
          if (result) {
            this.moveToStep(stepObj.step);
          }
        });
    }
  }

  /**
   * Get trip infomation for Individual
   */
  initTripInfo() {
    this.consultationProcessService.getTripInfo(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          const trip = result.json();
          if (trip && trip.length > 0) {
            let data = trip[0];
            let countries = '';
            if (data.tripCountries && data.tripCountries.length > 0) {
              for (let i = 0; i < data.tripCountries.length; i++) {
                countries += i === 0 ? data.tripCountries[i].name : ', ' + data.tripCountries[i].name;
              }
            }
            this.tripInfo = {
              country: countries,
              departureDate: data.departDate,
              returnDate: data.returnDate,
            };
          }
        }
      }
    );
  }

  /**
   * Get trip infomation for Group
   */
  initTripInfoGroup() {
    this.consultationProcessService.getTripInformationGroup(this.filterParam.id).subscribe(
      (result) => {
        if (result) {
          const trip = result.json();
          if (trip && trip.length > 0) {
            let data = trip[0];
            let countries = '';
            if (data.tripCountries && data.tripCountries.length > 0) {
              for (let i = 0; i < data.tripCountries.length; i++) {
                countries += i === 0 ? data.tripCountries[i].name : ', ' + data.tripCountries[i].name;
              }
            }
            this.tripInfo = {
              country: countries,
              departureDate: data.departDate,
              returnDate: data.returnDate,
            };
          }
        }
      }
    );
  }

  /**
   * function to update table when toggle menu
   */
  updateTableLayout() {
    // refresh the layout
    if (this.dataRow) {
      this.dataRow = [...this.dataRow];
    }
  }

  /**
     * function to reload page but keep current page
     * @param currentPage
     * @param dataRow
     * @param isDelete
  */
  reloadPage(currentPage, dataRow, isDelete = false, callback) {
    let pageNumber = currentPage;
    if (isDelete && dataRow.length === 1) {
        pageNumber = (currentPage - 1) < 0 ? 0 : (currentPage - 1);
    }
    callback.bind(this)({ offset: pageNumber });
  }

  isInDataEntryMode() {
    return (localStorage.getItem(AppConstants.localStorage.deUserId) !== 'null') ? true : false;
  }

  getTopPosition() {
    return window.screen.height > 800 ? 150 : 100;
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/base-consultation/base-consultation.component.ts